export const GOOGLE_MAP_OPTIONS = {
  fullscreenControl: false,
  scrollwheel: false,
  maxZoom: 16,
};
